import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Spec from "csi/core/Spec";
import StringRichLarge from "csi/heading/StringRichLarge";
import declare from "dojo/_base/declare";

const IngredientPerLanguageRenderer = declare(StringRichLarge, {

	/**
	 * @override
	 * Change index to Language.SysID
	 * Change node to FoodLabelDataSheetRevision
	 *
	 */
	reserveContext(ctx: Context, h: Heading) {
		ctx.keyValue = ctx.getNode().SysID;
		ctx.pushParams().setNodeURL(ctx.getParentURL());
	},

	/**
	 * @override
	 */
	releaseContext(ctx: Context, h: Heading) {
		ctx.pop();
		ctx.keyValue = null;
	},

	/**
	 * @override
	 * Disable filtering
	 */
	getQuerySpec(ctx: Context, h: Heading, spec: Spec) {
		return null;
	},

});

export = IngredientPerLanguageRenderer;